import styled from 'styled-components';

export const Readers = styled.div`

`;